import React, { useCallback, useState } from 'react';
import FlowHandlingButtons from '../Common/HandleNavigationAndSubmit';
import downloadIcon from "../../../assets/images/space-listing/download.svg";
import { Checkbox } from 'antd';
import { getProfileData, setProfileData } from '../Common/DataController';
import { DEFAULT_DATA_OBJ } from '../SpaceListingConstants';
import { spaceListingData } from '../Common/ProfileListingDataModal';
import { useParams } from 'react-router-dom';
import { sriLankanAgreement } from '../../HostOnBoarding/Common/SriLankanAgreement';

const Agreement = ({currentBlock}) => {
  const { country } = useParams();
  const [agreementDetails, setAgreementDetails] = useState(getProfileData()?.[DEFAULT_DATA_OBJ] ? getProfileData() : spaceListingData(country));

  const handleAgreementConfirmation = useCallback((name, newValue) => {
    const tempObj = Object.assign({}, agreementDetails, {
      ...agreementDetails,
      processStarted: true,
      [currentBlock]: agreementDetails?.[currentBlock].map(value => {
        value[name] = newValue;
        return value;
      }),
    });
    setAgreementDetails(tempObj);
    setProfileData(tempObj);
  }, []);

  const getFieldCurrentValue = (type) => {
    return agreementDetails?.[currentBlock]?.[0]?.[type];
  };

  return (
    <>
      <div className="left-side-inner-wrapper host-agreement">
        <div className="title-btn-wrapper">
          <h1 className="listing-page-title">Host agreement</h1>
          <a href="https://drive.google.com/file/d/1Oe90dMDunPADtJrfZFfivMNqkvW-wXrX/view?usp=sharing" target="_blank" rel="noopener noreferrer">
            <div
              className="download-btn"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                cursor: 'pointer',
              }}
            >
              <img src={downloadIcon} alt="Download Icon" style={{ width: '20px', height: '20px' }} />
              <span style={{ color: '#0000FF' }}>Download</span>
            </div>
          </a>
        </div>
        {sriLankanAgreement()}
        <Checkbox
          className="check-box"
          style={{ paddingTop: '16px', paddingBottom: '16px' }}
          value={getFieldCurrentValue('status')}
          defaultChecked={getFieldCurrentValue('status')}
          onChange={(value) => handleAgreementConfirmation('status', value?.target?.checked)}
        >
          I have read and accept the host agreement
        </Checkbox>
      </div>

      <FlowHandlingButtons nextButtonText={'Submit'} isSubmit={true} isActive={getFieldCurrentValue('status')} />
    </>
  );
};

export default Agreement;
